import { request, type DataInfoResponse, type PagedList } from './request';
import { buildListParams } from './params';
import type { DiseaseDto } from './types';

export interface DiseaseListOptions {
  pageIndex?: number;
  pageSize?: number;
  /** 病种名称搜索 */
  name?: string;
}

/** 优势病种列表（/disease/userGetDiseaseList，公开接口） */
export function fetchDiseaseList(options: DiseaseListOptions = {}): Promise<PagedList<DiseaseDto>> {
  const { pageIndex = 1, pageSize = 10, name = '' } = options;

  return request(
    '/disease/userGetDiseaseList',
    buildListParams({
      pageIndex,
      pageSize,
      state: 1,
      name,
    }),
  );
}

/** 优势病种详情（/disease/userGetDiseaseInfo，公开接口） */
export function fetchDiseaseInfo(id: number): Promise<DataInfoResponse<DiseaseDto>> {
  return request('/disease/userGetDiseaseInfo', { id });
}
